import { toast } from '@/components/ui/toast'
import type { OptionalCharge } from '@/components/shared'
import { useCreateQuoteOptionalFeeTemplate } from '@/hooks/useQuotes'
import {
  OptionalFeeDialog,
  type OptionalFeeDialogValue,
} from './OptionalFeeDialog'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
  onAdd: (charge: OptionalCharge) => void
  onUpdate: (charge: OptionalCharge) => void
  initialCharge?: OptionalCharge | null
  defaultVatRate: number
}

export function OptionalFeeDocumentDialog({
  open,
  onOpenChange,
  onAdd,
  onUpdate,
  initialCharge,
  defaultVatRate,
}: Props) {
  const create = useCreateQuoteOptionalFeeTemplate()

  const save = async (value: OptionalFeeDialogValue) => {
    if (initialCharge) {
      onUpdate({
        ...initialCharge,
        description: value.name,
        amount: value.amount,
        image_file_id: value.image_file_id,
        image_url: value.image_url,
        tax_rate: initialCharge.tax_rate ?? defaultVatRate,
      })
      return
    }

    const response = await create.mutateAsync({
      name: value.name,
      amount: value.amount,
      is_active: value.is_active,
      image_file_id: value.image_file_id,
    })
    const fee = response.data
    onAdd({
      id: fee?.id,
      type: fee?.type ?? 'custom',
      description: fee?.description ?? value.name,
      image_file_id: fee?.image_file_id ?? value.image_file_id,
      image_url: fee?.image_url ?? value.image_url,
      amount: fee?.amount ?? value.amount,
      tax_rate: defaultVatRate,
    })
    toast({ variant: 'success', title: response.message })
  }

  return (
    <OptionalFeeDialog
      open={open}
      onOpenChange={onOpenChange}
      initial={
        initialCharge
          ? {
              name: initialCharge.description ?? '',
              amount: initialCharge.amount,
              image_file_id: initialCharge.image_file_id,
              image_url: initialCharge.image_url,
              type: initialCharge.type,
            }
          : null
      }
      onSave={save}
      showActive={!initialCharge}
    />
  )
}
